export const flattenBillingInfo = ({ billingAddress, vatNumber }) => ({
  ...(billingAddress.city && { city: billingAddress.city }),
  ...(billingAddress.country && { country: billingAddress.country }),
  ...(billingAddress.firstName && { firstName: billingAddress.firstName }),
  ...(billingAddress.lastName && { lastName: billingAddress.lastName }),
  ...(billingAddress.line1 && { line1: billingAddress.line1 }),
  ...(billingAddress.postCode && { postCode: billingAddress.postCode }),
  ...(billingAddress.state && { state: billingAddress.state }),
  ...(vatNumber && { vatNumber })
})

export const unflattenBillingInfo = (billingInfo) => ({
  billingAddress: {
    city: billingInfo.city,
    country: billingInfo.country,
    firstName: billingInfo.firstName,
    lastName: billingInfo.lastName,
    line1: billingInfo.line1,
    postCode: billingInfo.postCode,
    state: billingInfo.state
  },
  vatNumber: billingInfo.vatNumber
})
